import moment from 'moment';
import min from 'lodash/min';
import max from 'lodash/max';
import mean from 'lodash/mean';
import uniq from 'lodash/uniq';

import { TOOLTIP_DATE_FORMAT } from '../constants';
import { VITALS_ACTIVITY_TYPE } from '../../../PatientHealthboard/constants';
import {
  convertCelsiusToFahrenheit,
  roundPrecision,
} from '../../../PatientHealthboard/utils';

const {
  BLOOD_PRESSURE,
  RESPIRATORY_RATE,
  BODY_SURFACE_AREA,
  BODY_TEMPERATURE,
} = VITALS_ACTIVITY_TYPE;

export const tooltipConverter = {
  getDate({ period, datePoint }) {
    const dateFormat = TOOLTIP_DATE_FORMAT[period];
    return moment(datePoint).format(dateFormat);
  },
  getDateBy({ period, datePoint }) {
    const dateFormat = TOOLTIP_DATE_FORMAT[period];
    return moment(datePoint).format(dateFormat);
  },
  getValue({ type, metric, shortMetric, datasets, points: [f] }) {
    switch (type) {
      case BLOOD_PRESSURE: {
        const { index, datasetIndex } = f;
        const dataset = datasets[datasetIndex];
        const code = dataset.label.split('.')[0];
        const codesDataSet = datasets.filter(item => item.label.includes(code));

        if (codesDataSet.length > 1) {
          const [first, second] = codesDataSet;
          return `${first.data[index]} / ${second.data[index]} ${metric}`;
        }

        return '';
      }
      case RESPIRATORY_RATE:
        return `${f.value} ${metric}`;
      case BODY_SURFACE_AREA:
        return `${roundPrecision(
          f.value,
          1,
          true,
        )} ${shortMetric}${String.fromCharCode(178)}`;
      case BODY_TEMPERATURE:
        return `${roundPrecision(f.value, 1, true)} ${metric}`;
      default:
        return '';
    }
  },
};

export const dataConverter = {
  average: {
    func: vals =>
      Object.values(vals)
        .map(v => Math.round(mean(v.filter(e => e))))
        .join('/'),
    label: 'Average',
  },
  float: {
    func: (vals, shouldConvertToFahrenheit) =>
      Object.values(vals)
        .map(v => mean(v.filter(e => e)), 1)
        .map(v => {
          const safeValue = shouldConvertToFahrenheit
            ? convertCelsiusToFahrenheit(v)
            : v;
          return roundPrecision(safeValue, 1, true);
        })
        .join('/'),
    label: 'Average',
  },
  minmax: {
    func: vals =>
      Object.values(vals)
        .map(v => uniq([min(v), max(v)]).join('-'))
        .join('/'),
    label: '',
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/helpers/converters.js